import React, { createContext, useContext, useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate, useLocation, replace } from 'react-router-dom';
import './App.css';
import Main from '../src/Components/Main';
import Header from '../src/Components/Header';
import ProductsSection from './Components/ProductsSection';
import Projects from './Components/Projects';
import Footer from './Components/Footer';
import Details from './Components/Details';
import ContactUs from './Components/ContactUs';
import AboutUs from './Components/AboutUs';
import SignupLogin from './Components/SIgnupLogin';

import Order from './Components/Order';
import MyOrders from './Components/MyOrders';
import ViewOrder from './Components/ViewOrder';
import Edit from './Components/Edit';
import LoginWrapper from './Components/LoginWrapper';

const Usercontext = createContext(null)

function App() {
  const [userdata,setuserdata] = useState(null)
  const navigate = useNavigate();
  const location = useLocation();
  const [headerClass, setHeaderClass] = useState('');

  const handleScroll = () => {
    if (window.scrollY > 50) {
      setHeaderClass('sticky');
    } else {
      setHeaderClass('');
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);





  return (
    <>
      <Usercontext.Provider value={{userdata,setuserdata}}>
      <Header className={headerClass} />
      <Routes>
        <Route 
          path="/" 
          element={
            <>
              <Main />
              <ProductsSection />
              <Projects />
            </>
          } 
        />
        <Route 
          path="/details" 
          element={<Details />} 
        />
        <Route 
          path="/contact" 
          element={<ContactUs/>} 
        />
        <Route 
          path="/about" 
          element={<AboutUs/>} 
        />
        <Route 
          path="/signuplogin" 
          element={<SignupLogin/>} 
        />
        <Route 
          path="/orders" 
          element={<LoginWrapper><Order/></LoginWrapper>} 
        />
        <Route 
          path="/myorders" 
          element={<LoginWrapper><MyOrders/></LoginWrapper>} 
        />
        
        <Route path='/vieworders' element={<LoginWrapper><ViewOrder/></LoginWrapper>}/>

        {userdata?.isAdmin ? 
          <Route path='/edit' element={<LoginWrapper><Edit/></LoginWrapper>}/>
          :
          null
        }

        <Route path='*' element={<h1>No Page Found</h1>} />
      </Routes>
      <Footer />
      </Usercontext.Provider>
      </>
    
  );
}

export default App;
export {Usercontext}
